import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#__clip0_5610_20483)" }, [
      _createElementVNode("path", {
        d: "M10.6322 6.2098C9.29964 5.38977 7.58398 6.34847 7.58398 7.91311V18.0882C7.58398 19.6528 9.29964 20.6115 10.6322 19.7915L18.8994 14.704C20.1685 13.923 20.1685 12.0783 18.8994 11.2973L10.6322 6.2098Z",
        fill: "currentColor"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "__clip0_5610_20483" }, [
        _createElementVNode("rect", {
          width: "26",
          height: "26",
          fill: "currentColor"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }